import { render, staticRenderFns } from "./scheduleAccordion.vue?vue&type=template&id=710b0d46&scoped=true"
import script from "./scheduleAccordion.vue?vue&type=script&lang=js"
export * from "./scheduleAccordion.vue?vue&type=script&lang=js"
import style0 from "./scheduleAccordion.vue?vue&type=style&index=0&id=710b0d46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710b0d46",
  null
  
)

export default component.exports